import { Damage } from './damage.class';
export var AdditionalsDamageStatus;
(function (AdditionalsDamageStatus) {
    AdditionalsDamageStatus["not_modified"] = "not_modified";
    AdditionalsDamageStatus["added"] = "added";
    AdditionalsDamageStatus["edited"] = "edited";
    AdditionalsDamageStatus["deleted"] = "deleted";
})(AdditionalsDamageStatus || (AdditionalsDamageStatus = {}));
export var AdditionalsDamageImageState;
(function (AdditionalsDamageImageState) {
    AdditionalsDamageImageState["new"] = "new";
    AdditionalsDamageImageState["uploading"] = "uploading";
    AdditionalsDamageImageState["uploaded"] = "uploaded";
    AdditionalsDamageImageState["error"] = "error";
})(AdditionalsDamageImageState || (AdditionalsDamageImageState = {}));
export class AdditionalsDamage extends Damage {
    action;
    // Esto huele a Smell, Abordar en primeros refactors
    status;
    images = [];
    constructor(area, severity, typology, id, partId, partDescription, assemblyTime, labourTime, paintTime, paintMaterials, partPrice, operation, status, partReference, action, images = []) {
        const imagesData = images.map((key) => ({
            url: '',
            key,
            state: AdditionalsDamageImageState.uploaded
        }));
        const damage = new Damage({
            damages: [
                {
                    area,
                    is_deleted: false,
                    origin: 'claim',
                    severity,
                    typology,
                    uuid: id,
                    is_extra: true,
                    from: 'bodyshop',
                    custom: partId === 'custom'
                }
            ],
            part: {
                description: partDescription,
                id: partId,
                zone: null
            },
            estimation: {
                strip_assembly: assemblyTime,
                labour_time: labourTime,
                paint_time: paintTime,
                paint_materials: paintMaterials,
                part_price: partPrice,
                operation,
                part_reference: partReference
            }
        });
        const data = damage.export();
        super(data.mainDetection, data.otherDetection);
        this.status = status;
        this.action = action;
        this.images = imagesData;
    }
    clone() {
        const damage = new AdditionalsDamage(this.area, this.severity, this.typology, this.uuid, this.partId, this.description, this.estimation.assembly.time ?? 0, this.estimation.labour.time ?? 0, this.estimation.paint.time ?? 0, this.estimation.paint.materials ?? 0, this.estimation.piece ?? 0, this.getOperation(), this.status, this.estimation.reference, this.action, this.images.map(({ key }) => key).filter((key) => Boolean(key)));
        if (!this.estimation.Price) {
            return damage;
        }
        damage.estimation.updatePrice(this.estimation.Price);
        return damage;
    }
    getOperation() {
        const { operation } = this.estimation;
        if (operation === 'repair' || operation === 'replace') {
            return operation;
        }
        throw new Error(`Invalid or missing operation '${operation}' for additional damage`);
    }
}
